import React, { useState } from "react";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import dateFormat, { masks } from "dateformat";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { BrowserRouter as Router, Link, withRouter } from "react-router-dom";
import { PdfReader } from "../../utils/DocumentViewer";
import { Modal, Button } from "react-bootstrap";
class InvoiceValidationTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceDetails: this.props.invoiceDetails,
      mgRateTotal: 0,
      mgAmountTotal: 0,
      netSalesTotal: 0,
      rsTotal: 0,
      rsAmountTotal: 0,
      fitoutTotal: 0,
      camTotal: 0,
      netChargeTotal: 0,
      invoiceAmountTotal: 0,
      currentDocument: "",
      pageNo: 1,
    };
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  render() {
    return (
      <div className="tabHolder invoiceTabs mb-4">
        <div className="row tabForm mt-4">
          <Tabs>
            {Object.keys(this.state.invoiceDetails).map((event, index) => {
              return <Tab>{event}</Tab>;
            })}
            {Object.keys(this.state.invoiceDetails).map((event, index) => {
              return (
                <TabPanel>
                  {Object.keys(this.state.invoiceDetails[event]).map(
                    (chargeDetails, chargeType) => {
                      return (
                        <div className="container-fluid p-0">
                          <div className="row prospectAccordion">
                            <div className="col-lg-12">
                              <Accordion>
                                <Accordion.Item eventKey="1">
                                  <Accordion.Header>
                                    {chargeDetails}
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <div className="container">
                                      <div className="row">
                                        {Object.keys(
                                          this.state.invoiceDetails[event][
                                            chargeDetails
                                          ]
                                        ).map(
                                          (chargeLogic, chargeLogicindex) => {
                                            return (
                                              <table>
                                                <thead>
                                                  <tr>
                                                    <th scope="col">Month</th>
                                                    <th scope="col">
                                                      Charge Type
                                                    </th>
                                                    <th scope="col">
                                                      Charge Logic
                                                    </th>
                                                    <th scope="col">MG Rate</th>
                                                    <th scope="col">
                                                      MG Amount
                                                    </th>
                                                    <th scope="col">
                                                      Net Sales
                                                    </th>
                                                    <th scope="col">RS %</th>
                                                    <th scope="col">
                                                      RS Amount
                                                    </th>
                                                    <th scope="col">
                                                      Fitout Rent Amount
                                                    </th>
                                                    <th scope="col">
                                                      CAM Amount
                                                    </th>
                                                    <th scope="col">
                                                      Net Charge Amount
                                                    </th>
                                                    <th scope="col">
                                                      Invoice Amount
                                                    </th>
                                                    <th scope="col">
                                                      Variance
                                                    </th>
                                                    <th scope="col">
                                                      View Invoice
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    <td>{event}</td>
                                                    <td>{chargeDetails}</td>
                                                    <td>{chargeLogic}</td>
                                                    <td>
                                                      {
                                                        this.state
                                                          .invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["mg_rate"]
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        this.state
                                                          .invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["mg_amount"]
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        this.state
                                                          .invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["net_sales"]
                                                      }
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>
                                                      {
                                                        this.state
                                                          .invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["fitoutRate"]
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        this.state
                                                          .invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["cam_amt"]
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        this.state
                                                          .invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["net_sales"]
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        this.state
                                                          .invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["invoice_amount"]
                                                      }
                                                    </td>
                                                    <td></td>
                                                    <td>
                                                      <Link
                                                        to={"#"}
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          this.state.currentDocument =
                                                            this.state.invoiceDetails[
                                                              event
                                                            ][chargeDetails][
                                                              chargeLogic
                                                            ]["document_link"];
                                                          this.state.pageNo = 1;
                                                          this.openModal();
                                                        }}
                                                      >
                                                        View Invoice
                                                      </Link>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                                <tfoot>
                                                  <tr>
                                                    <th>Total</th>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td>
                                                      {
                                                        (this.state.mgRateTotal +=
                                                          Number(
                                                            this.state
                                                              .invoiceDetails[
                                                              event
                                                            ][chargeDetails][
                                                              chargeLogic
                                                            ]["mg_rate"]
                                                          ))
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        (this.state.invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["mg_amount"] +=
                                                          this.state.mgAmountTotal)
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        (this.state.invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["net_sales"] +=
                                                          this.state.netSalesTotal)
                                                      }
                                                    </td>
                                                    <td>
                                                      {this.state.rsTotal}
                                                    </td>
                                                    <td>
                                                      {this.state.rsAmountTotal}
                                                    </td>
                                                    <td>
                                                      {
                                                        (this.state.invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["fitoutRate"] +=
                                                          this.state.fitoutTotal)
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        (this.state.invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["cam_amt"] +=
                                                          this.state.camTotal)
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        (this.state.invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["net_sales"] +=
                                                          this.state.netChargeTotal)
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        (this.state.invoiceDetails[
                                                          event
                                                        ][chargeDetails][
                                                          chargeLogic
                                                        ]["invoice_amount"] +=
                                                          this.state.invoiceAmountTotal)
                                                      }
                                                    </td>
                                                    <td>
                                                      {this.state.varianceTotal}
                                                    </td>
                                                    <td></td>
                                                  </tr>
                                                </tfoot>
                                              </table>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </TabPanel>
              );
            })}
          </Tabs>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              size="lg"
              className="documentModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <div className="container modalBreadCrumbs">
                    <div className="row">
                      <div className="col-lg-12">
                        <ul>
                          <li>Document</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <PdfReader
                      url={this.state.currentDocument}
                      pageNumber={this.state.pageNo}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(InvoiceValidationTab);
